import React from 'react'

import { InfoOutlined, WarningAmberRounded } from '@mui/icons-material'
import { Stack, Typography, alpha, useTheme } from '@mui/material'

export const TARIFF_ALERT_TEXT = 'Preço muda por horário'

export const TARIFF_ALERT_HINT =
  'O preço do kWh nesta estação muda conforme o horário, o dia da semana e os feriados. Confira a grade na tela do carregador antes de iniciar a recarga.'

export const IDLE_ALERT_TEXT = 'Ociosidade muda por horário'

export const IDLE_ALERT_HINT =
  'O valor por minuto da ociosidade nesta estação muda conforme o horário, o dia da semana e os feriados. Confira a grade na tela do carregador antes de iniciar a recarga.'

interface TariffAlertProps {
  onClick?: () => void
  opaque?: boolean
  text?: string
  icon?: React.ElementType
}

export const TariffAlert: React.FC<TariffAlertProps> = ({
  onClick,
  opaque,
  text = TARIFF_ALERT_TEXT,
  icon: Icon = WarningAmberRounded,
}) => {
  const theme = useTheme()
  const color = theme.palette.tariff.main

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={0.5}
      role={onClick ? 'button' : undefined}
      aria-label={onClick ? `${text}. Ver detalhes` : undefined}
      onClick={(event) => {
        if (!onClick) return
        event.stopPropagation()
        onClick()
      }}
      sx={{
        alignSelf: 'flex-start',
        maxWidth: '100%',
        paddingX: 1,
        paddingY: 0.25,
        borderRadius: 1.5,
        border: '1px solid',
        borderColor: alpha(color, 0.28),
        backgroundColor: opaque ? 'background.paper' : alpha(color, 0.1),
        backgroundImage: opaque ? `linear-gradient(${alpha(color, 0.1)}, ${alpha(color, 0.1)})` : 'none',
        boxShadow: opaque ? '0 1px 4px rgba(0,0,0,0.25)' : 'none',
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <Icon sx={{ fontSize: 14, color, flexShrink: 0 }} />
      <Typography variant="caption" fontWeight={700} color={color} lineHeight={1.35}>
        {text}
      </Typography>
      <InfoOutlined sx={{ fontSize: 13, color, flexShrink: 0 }} />
    </Stack>
  )
}
